// Feature keys stored in subscription_plans.features as JSON array
// When a plan has a feature key, users on that plan can access it

export const PLAN_FEATURES = {
  SCRAPE_SHOPIFY: 'scrape_shopify',
  SCRAPE_WOOCOMMERCE: 'scrape_woocommerce',
  AI_FIX: 'ai_fix',
  PUSH_SHOPIFY: 'push_shopify',
  PUSH_WOOCOMMERCE: 'push_woocommerce',
  CSV_IMPORT: 'csv_import',
  CSV_TRANSFORM: 'csv_transform',
  BULK_EDIT: 'bulk_edit',
  GMC_SCANNER: 'gmc_scanner',
  GMC_FIXER: 'gmc_fixer',
  GMC_POLICY_FIXER: 'gmc_policy_fixer',
  EXPORT_CSV: 'export_csv',
} as const;

export type PlanFeatureKey = typeof PLAN_FEATURES[keyof typeof PLAN_FEATURES];

// Feature metadata for admin UI
export const FEATURE_OPTIONS: { key: PlanFeatureKey; label: string; tier: string }[] = [
  { key: 'scrape_shopify', label: 'Scrape Shopify Products', tier: 'Basic' },
  { key: 'export_csv', label: 'Export CSV', tier: 'Basic' },
  { key: 'bulk_edit', label: 'Bulk Edit Products', tier: 'Basic' },
  { key: 'scrape_woocommerce', label: 'Scrape WooCommerce Products', tier: 'Standard' },
  { key: 'ai_fix', label: 'AI Product Fixer', tier: 'Standard' },
  { key: 'push_shopify', label: 'Push to Shopify', tier: 'Standard' },
  { key: 'push_woocommerce', label: 'Push to WooCommerce', tier: 'Standard' },
  { key: 'csv_import', label: 'Import CSV', tier: 'Standard' },
  { key: 'csv_transform', label: 'CSV Transformer', tier: 'Standard' },
  { key: 'gmc_scanner', label: 'GMC Compliance Scanner', tier: 'Pro' },
  { key: 'gmc_fixer', label: 'GMC AI Fixer', tier: 'Pro' },
  { key: 'gmc_policy_fixer', label: 'AI Privacy Policy Fixer', tier: 'Pro' },
];

// Preset feature sets for quick plan setup
export const PLAN_PRESETS = {
  basic: ['scrape_shopify', 'export_csv', 'bulk_edit'],
  standard: ['scrape_shopify', 'export_csv', 'bulk_edit', 'scrape_woocommerce', 'ai_fix', 'push_shopify', 'push_woocommerce', 'csv_import', 'csv_transform'],
  pro: ['scrape_shopify', 'export_csv', 'bulk_edit', 'scrape_woocommerce', 'ai_fix', 'push_shopify', 'push_woocommerce', 'csv_import', 'csv_transform', 'gmc_scanner', 'gmc_fixer', 'gmc_policy_fixer'],
};
